var SelectionType;
(function (SelectionType) {
    SelectionType["MULTIPLE"] = "multiple";
    SelectionType["MULTIPLE_GROUP"] = "multiple-group";
    SelectionType["NONE"] = "none";
    SelectionType["SINGLE"] = "single";
    SelectionType["SINGLE_GROUP"] = "single-group";
})(SelectionType || (SelectionType = {}));
export default SelectionType;
//# sourceMappingURL=selection-type.js.map